import { gql } from "@apollo/client";

export const CREATE_CAPITAL_PROVINCE = gql`
  mutation CreateCapitalProvince($input: CapicalProvincesInput) {
    createCapitalProvince(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_CAPITAL_PROVINCE = gql`
  query GetCapitalProvince {
    getCapitalProvince {
      _id
      isDefault
      capital_province_name_en
      capital_province_name_kh
      capital_province_code
      capital_province_type
    }
  }
`;

export const UPDATE_CAPITAL_PROVINCE = gql`
  mutation UpdateCapitalProvince($id: ID, $input: CapicalProvincesInput) {
    updateCapitalProvince(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_CAPITAL_PROVINCE = gql`
  mutation DeleteCapitalProvince($id: ID) {
    deleteCapitalProvince(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_CAPITAL_PROVINCE_BY_ID = gql`
  query GetCapitalProvinceById($id: ID) {
    getCapitalProvinceById(_id: $id) {
      _id
      isDefault
      capital_province_name_en
      capital_province_name_kh
      capital_province_code
      capital_province_type
    }
  }
`;

export const CREATE_DISTRICT_MUNICIPALITY = gql`
  mutation CreateDistrictMunicipality($input: DistrictMunicipalityInput) {
    createDistrictMunicipality(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_DISTRICT_MUNICIPALITY = gql`
  mutation UpdateDistrictMunicipality(
    $id: ID
    $input: DistrictMunicipalityInput
  ) {
    updateDistrictMunicipality(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_DISTRICT_MUNICIPALITY = gql`
  mutation DeleteDistrictMunicipality($id: ID) {
    deleteDistrictMunicipality(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_COMMUNE_SANGKAT = gql`
  mutation DeleteCommuneSangkat($id: ID) {
    deleteCommuneSangkat(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_COMMUNE_SANGKAT = gql`
  mutation UpdateCommuneSangkat($id: ID, $input: CommuneSangkatInput) {
    updateCommuneSangkat(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_COMMUNE_SANGKAT = gql`
  mutation CreateCommuneSangkat($input: CommuneSangkatInput) {
    createCommuneSangkat(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_VILLAGE = gql`
  mutation CreateVillage($input: VillageInput) {
    createVillage(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_VILLAGE = gql`
  mutation UpdateVillage($id: ID, $input: VillageInput) {
    updateVillage(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_VILLAGE = gql`
  mutation DeleteVillage($id: ID) {
    deleteVillage(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
